import { taxDataService } from '@/_services';
import router from '@/router'

export default {

  getAll({dispatch, commit}, {page, sort, search}) {
    dispatch("alert/clear", {}, {root: true})
    taxDataService.getAll(page, sort, search)
      .then(
        taxData => {
          commit("setTaxData", taxData);
        },
        error => {
          dispatch("alert/error", error, {root: true})
        }
      )
  },
  createTaxData({dispatch, commit}, {taxData}) {
    dispatch("alert/clear", {}, {root:true});
    return taxDataService.createTaxData(taxData)
      .then(
        () => {
          dispatch("taxData/getAll", {page: 0}, {root: true});
          dispatch("alert/success", "Se agregaron los datos de facturación con éxito", {root:true});
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject(error);
        }
      )
  },
  updateTaxData({dispatch, commit}, {taxData}) {
    dispatch("alert/clear", {}, {root:true});
    return taxDataService.updateTaxData(taxData)
      .then(
        () => {
          dispatch("taxData/getAll", {page: 0}, {root: true});
          dispatch("alert/success", "Se agregaron los datos de facturación con éxito", {root:true});
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject(error);
        }
      )
  },

}
